export default class ZonePool {
  private static inUse: string[] = new Array<string>();
  private readonly pool: string[];

  constructor(zones: string[]) {
    this.pool = zones;
  }

  public getZone(): string {
    const freeZone = this.pool.find(zone => !ZonePool.inUse.includes(zone));

    if (freeZone) {
      ZonePool.inUse.push(freeZone);
      return freeZone;
    } else {
      console.warn(
        'Running out of free zones on "' +
          window.location.href +
          '", using fallback ad, please supply new zones to the zone pool.'
      );
      return null;
    }
  }

  public freeZone(zoneId: string): boolean {
    if (zoneId) {
      const index = ZonePool.inUse.findIndex(zone => zone.localeCompare(zoneId) === 0);
      if (index >= 0) {
        ZonePool.inUse.splice(index, 1);
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public freeAllZones() {
    ZonePool.inUse.splice(0, ZonePool.inUse.length);
  }
}
